import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { ComumModule } from './../../../shared/comum.module';
import { translateLoaderNBS } from './../../../shared/translate-loader/translateLoader';
import { PecasSolicitadasCadastroComponent } from './pecas-solicitadas-cadastro/pecas-solicitadas-cadastro.component';
import { PecasSolicitadasFiltroComponent } from './pecas-solicitadas-filtro/pecas-solicitadas-filtro.component';
import { PecasSolicitadasListaComponent } from './pecas-solicitadas-lista/pecas-solicitadas-lista.component';
import { PecasSolicitadasService } from './pecas-solicitadas-service/pecas-solicitadas.service';
import { PecasSolicitadasComponent } from './pecas-solicitadas.component';
import { FileUploadModule } from './../../../shared/fileupload/fileupload';

@NgModule({
  imports: [
    HttpClientModule,
    FormsModule,
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    ComumModule,
    TranslateModule.forRoot(translateLoaderNBS),
    FileUploadModule
  ],
  exports: [
    PecasSolicitadasComponent
  ],
  declarations: [
    PecasSolicitadasComponent,
    PecasSolicitadasCadastroComponent,
    PecasSolicitadasFiltroComponent,
    PecasSolicitadasListaComponent
  ],
  providers: [
    PecasSolicitadasService
  ]
})
export class PecasSolicitadasModule { }
